import type { ReactNode } from 'react';

import { cx } from './cx';

export type BadgeTone = 'primary' | 'neutral' | 'teal';

interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
}

/** Small rounded pill — red "Primary" style, neutral, or teal accents. */
export function Badge({ tone = 'neutral', children }: BadgeProps) {
  return <span className={cx('rfp-badge', `rfp-badge--${tone}`)}>{children}</span>;
}
